import React, { useState } from 'react'

import useUser from "../../hooks/useUser";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Container from 'react-bootstrap/esm/Container';
import { findUserAdminInDB } from '../../api/apiAdmin';

const Login = () => {
  const [adminUser, setAdminUser] = useUser();
  const [inputAdmin, setInputAdmin] = useState({user:'',password:''});
  const [loginError, setLoginError] = useState(false);
  const handleChange = (e)=>{
    e.preventDefault();
    let name= e.target.name;
    let value= e.target.value; 
    //console.log(name,value);
    setInputAdmin({
      ...inputAdmin,
      [name]: value
    })
  }
  const handleLogin = async(e)=>{
    e.preventDefault();
    //console.log('Checando user...')
    const resultLogin = await findUserAdminInDB(inputAdmin);
    //console.log('resultLogin:..',resultLogin);
    
    if (resultLogin.response.data.resultLogin==='done'){
      console.log('Login SuccessFull');
      setAdminUser({
        ...adminUser,
        user: inputAdmin.user,
        logged: true
      })
    }else if (resultLogin.response.data.resultRoot){
      console.log('Login Root SuccessFull');
      setAdminUser({
        ...adminUser,
        user: inputAdmin.user,
        rootUser: true
      })
    }else {
      console.log('Login Error');
      setLoginError(true);
    }
  }
  return (
    <Form className='w-50 ms-auto me-auto'>
      <Container>
      <Form.Group className="mb-3" controlId="formBasic">
        <Form.Label>User:</Form.Label>
        <Form.Control type="text" name='user' value={inputAdmin.user} onChange={handleChange} placeholder="user" />
      </Form.Group>

      <Form.Group className="mb-3" controlId="formBasicPassword">
        <Form.Label>Password</Form.Label>
        <Form.Control type="password" name='password' autoComplete="off" value={inputAdmin.password} onChange={handleChange} placeholder="Password" />
      </Form.Group>
      
      <Button variant="primary" onClick={handleLogin} type="submit">
        Login
      </Button>
      {loginError&& <h6 className='text-danger fs-6 text-center'>Login Error...</h6> }
      </Container>
    </Form>
  )
}

export default Login